import styled from "styled-components";
export const HeroIconImage = styled.img `
    width: 52px;
    height: 64px;
`;
